import Repository from "../../repository";

export default {
    LoginDriver: (payload) => Repository.post(`/api/AuthenticationDriver/LoginDriver`, payload),
    RefreshToken: (payload) => Repository.post(`/api/AuthenticationDriver/RefreshToken`, payload),
    CheckToken: (payload) => Repository.post(`/api/AuthenticationDriver/CheckToken`, payload),
    ChangePasswordDriver: (payload) => Repository.post(`/api/AuthenticationDriver/ChangePasswordDriver`, payload),
}